import React from 'react';
import PropTypes from 'prop-types';

// Components
import CybsButton from '@cybs-ui/components/lib/button';
import DropdownBase from './base.component';
import DropdownTrigger from './trigger.component';

const MenuButton = props => {
  const {
    actions,
    anchorOffset,
    focusRef,
    dataTest,
    disabled,
    onChange,
    iconClass,
    iconType
  } = props;
  return (
    <>
      {actions && actions.length ? (
        <div /* eslint-disable-line  */
          onKeyDown={e => {
            const types = ['Enter', 'ArrowUp', 'ArrowDown'];
            if (e.key && types.includes(e.key)) e.stopPropagation();
          }}
        >
          {/** Only actions drop down. Menu created in the navManu */}
          {!disabled ? (
            <DropdownBase
              anchorOffset={anchorOffset}
              items={actions}
              itemToString={item => (item ? item.label : '')}
              labelKey="label"
              isMenu
              onChange={el => (el.onClick ? el.onClick() : onChange(el))}
            >
              {triggerProps => (
                <DropdownTrigger
                  focusRef={focusRef}
                  dataTest={dataTest}
                  {...triggerProps}
                  elementType="button"
                  elementProps={{
                    variant: 'icon',
                    iconType,
                    iconClass
                  }}
                />
              )}
            </DropdownBase>
          ) : (
            <CybsButton
              dataTest={`${dataTest}-dropdown`}
              iconType={iconType}
              iconClass={iconClass}
              variant="icon"
              disabled
            />
          )}
        </div>
      ) : null}
    </>
  );
};

MenuButton.displayName = 'More Actions for Action Bar';

MenuButton.propTypes = {
  anchorOffset: PropTypes.shape({
    horizontal: PropTypes.string,
    vertical: PropTypes.string
  }),
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      label: PropTypes.string,
      title: PropTypes.string,
      value: PropTypes.string,
      onClick: PropTypes.func
    })
  ).isRequired,
  dataTest: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  focusRef: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  // onClick: PropTypes.func.isRequired,
  iconClass: PropTypes.string.isRequired,
  iconType: PropTypes.string.isRequired
};

MenuButton.defaultProps = {
  anchorOffset: {
    horizontal: 'left',
    vertical: 'bottom'
  },
  disabled: false,
  onChange: el => {
    console.warn('No onChange Function Specified. You clicked:', el);
  }
};

export default MenuButton;
